// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface ContentFilterIconSignature {
  Element: SVGSVGElement;
}

export const ContentFilterIcon: TOC<ContentFilterIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M6 2H18C19.104 2 20 2.898 20 4V8C20 8.257 19.902 8.512 19.707 8.707L15 13.414V17C15 17.266 14.895 17.52 14.707 17.707L10.707 21.707C10.516 21.898 10.26 22 10 22C9.871 22 9.741 21.976 9.617 21.924C9.244 21.769 9 21.404 9 21V13.415L4.293 8.707C4.098 8.512 4 8.256 4 8V4C4 2.898 4.896 2 6 2ZM13 13C13 12.735 13.105 12.481 13.293 12.293L18 7.586V4H6V7.586L10.707 12.293C10.895 12.48 11 12.735 11 13V18.586L13 16.586V13Z"/>
</svg>
</template>;